import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'app-sort',
    templateUrl: './sort.component.html',
})
export class SortComponent implements OnInit{

    @Input('sort') sort: any;
    @Input('column') column: any;

    constructor(){

    }

    ngOnInit(){

    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/sort/sort.component.ts